import React from 'react';
import { ThemeProvider, StyleSheetManager } from 'styled-components';
import { theme } from 'styles/theme';

interface ThemeControllerProps {
  children: React.ReactNode;
}

function shouldForwardProp(propName: string, target: any) {
  if (typeof target === "string") {
    return !propName.startsWith('$');
  }
  return true;
}

export const ThemeController: React.FC<ThemeControllerProps> = ({ children }) => (
  <StyleSheetManager shouldForwardProp={shouldForwardProp}>
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
  </StyleSheetManager>
);
